module.exports = __webpack_public_path__ + "static/img/up.84c918f6.svg";